import { render, staticRenderFns } from "./GerenciamentoPermissoes.vue?vue&type=template&id=67446ef2&scoped=true&"
import script from "./GerenciamentoPermissoes.vue?vue&type=script&lang=js&"
export * from "./GerenciamentoPermissoes.vue?vue&type=script&lang=js&"
import style0 from "./GerenciamentoPermissoes.vue?vue&type=style&index=0&id=67446ef2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67446ef2",
  null
  
)

export default component.exports